/**
 * Created by caoyu on 2021/12/4.
 */
import Vue from 'vue'

import ExportExcel from "./ExportExcel.vue"
Vue.component('ExportExcel', ExportExcel);




// WEBPACK FOOTER //
// ./src/common/excel/excel.js